import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/generic-image/index.js';
import css_248z from './image-block-container.scss.js';

class ImageBlockContainer extends s {
    constructor() {
        super(...arguments);
        this.alignment = 'left';
        this.aspectRatio = '16:9';
        this.src = '';
        this.alt = '';
        this.caption = '';
        this.decorative = '';
        this.interactive = false;
        this.href = null;
        this.target = null;
        this.fullWidth = false;
    }
    render() {
        const componentClasses = `container ${this.alignment}`;
        return $ `<div class="${componentClasses}"><div class="media-wrapper"><generic-image alignment="${this.alignment}" src="${this.src}" alt="${this.alt}" aspect-ratio="${this.aspectRatio || 'original'}" caption="${this.caption}" decorative="${this.decorative}" href="${this.href || ''}" target="${this.target || ''}"></generic-image></div></div>`;
    }
}
ImageBlockContainer.styles = css_248z;
__decorate([
    e({ type: String })
], ImageBlockContainer.prototype, "alignment", void 0);
__decorate([
    e({ type: String, attribute: 'aspect-ratio' })
], ImageBlockContainer.prototype, "aspectRatio", void 0);
__decorate([
    e({ type: String })
], ImageBlockContainer.prototype, "src", void 0);
__decorate([
    e({ type: String })
], ImageBlockContainer.prototype, "alt", void 0);
__decorate([
    e({ type: String })
], ImageBlockContainer.prototype, "caption", void 0);
__decorate([
    e({ type: String })
], ImageBlockContainer.prototype, "decorative", void 0);
__decorate([
    e({ type: Boolean })
], ImageBlockContainer.prototype, "interactive", void 0);
__decorate([
    e({ type: String })
], ImageBlockContainer.prototype, "href", void 0);
__decorate([
    e({ type: String })
], ImageBlockContainer.prototype, "target", void 0);
__decorate([
    e({ type: Boolean, attribute: 'full-width', reflect: true })
], ImageBlockContainer.prototype, "fullWidth", void 0);
customElements.define('image-block-container', ImageBlockContainer);

export { ImageBlockContainer };
